import { Entry } from '../Entry'

export function Entry20240508() {
  return (
    <Entry title="08/05/2023 - v3.7.0">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15555/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
